// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Contact from "./contact.js"

const modelClassData = {
  "attributes": {
    "contact_group_id": {
      "column": {
        "default": null,
        "name": "contact_group_id",
        "null": true,
        "type": "uuid"
      },
      "name": "contact_group_id",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "identifier": {
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      },
      "name": "identifier",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ContactGroup",
  "collectionKey": "contact_groups",
  "collectionName": "contact_groups",
  "i18nKey": "contact_group",
  "camelizedLower": "contactGroup",
  "name": "ContactGroup",
  "nameDasherized": "contact-group",
  "pluralName": "contact_groups",
  "ransackable_associations": [
    {
      "className": "ActivityGroup",
      "collectionName": "activity_groups",
      "foreignKey": "contact_group_id",
      "name": "activity_groups",
      "macro": "has_many",
      "resource_name": "ActivityGroup",
      "through": null
    },
    {
      "className": "ContactGroup",
      "collectionName": "contact_groups",
      "foreignKey": "contact_group_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "ContactGroup",
      "through": null
    },
    {
      "className": "ContactGroup",
      "collectionName": "contact_groups",
      "foreignKey": "contact_group_id",
      "name": "contact_group",
      "macro": "belongs_to",
      "resource_name": "ContactGroup",
      "through": null
    },
    {
      "className": "ContactGroupContact",
      "collectionName": "contact_group_contacts",
      "foreignKey": "contact_group_id",
      "name": "contact_group_contacts",
      "macro": "has_many",
      "resource_name": "ContactGroupContact",
      "through": null
    },
    {
      "className": "ContactGroup",
      "collectionName": "contact_groups",
      "foreignKey": "contact_group_id",
      "name": "contact_groups",
      "macro": "has_many",
      "resource_name": "ContactGroup",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "contact_group_contacts"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "ContactGroup",
      "collectionName": "contact_groups",
      "foreignKey": "contact_group_id",
      "name": "parent",
      "macro": "belongs_to",
      "resource_name": "ContactGroup",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "children_count",
      "column": {
        "default": 0,
        "name": "children_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "contact_group_id",
      "column": {
        "default": null,
        "name": "contact_group_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "depth",
      "column": {
        "default": 0,
        "name": "depth",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "lft",
      "column": {
        "default": null,
        "name": "lft",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_contact_group_id",
      "column": {
        "default": null,
        "name": "old_contact_group_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "rgt",
      "column": {
        "default": null,
        "name": "rgt",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "contact_group_contacts"
    },
    {
      "className": "ContactGroup",
      "collectionName": "contact_groups",
      "foreignKey": "contact_group_id",
      "name": "contact_group",
      "macro": "belongs_to",
      "resource_name": "ContactGroup",
      "through": null
    }
  ],
  "paramKey": "contact_group",
  "primaryKey": "id"
}

/** Frontend model for ContactGroup. */
export default class ContactGroup extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  contactGroupId() {
    return this.readAttributeUnderscore("contact_group_id")
  }

  /** @returns {boolean} */
  hasContactGroupId() {
    const value = this.contactGroupId()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  identifier() {
    return this.readAttributeUnderscore("identifier")
  }

  /** @returns {boolean} */
  hasIdentifier() {
    const value = this.identifier()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact.js").default>} */
  contacts() {
    return new Collection(
      {
        reflectionName: "contacts",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "ContactGroup",
            id: this.primaryKey(),
            reflection: "contacts"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  loadContacts() {
    return this._loadHasManyReflection(
      {
        reflectionName: "contacts",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "ContactGroup",
            id: this.primaryKey(),
            reflection: "contacts"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  ensureContactsLoaded() {
    return this.ensureAssociationLoaded("contacts")
  }

  /** @returns {import("./contact-group.js").default | null} */
  contactGroup() {
    return this._readBelongsToReflection({modelClass: ContactGroup, reflectionName: "contact_group"})
  }

  /** @returns {Promise<import("./contact-group.js").default | null>} */
  loadContactGroup() {
    if (!("contactGroupId" in this)) throw new Error("Foreign key method wasn't defined: contactGroupId")

    const id = this.contactGroupId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact_group",
        model: this,
        modelClass: ContactGroup
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact-group.js").default | null>} */
  ensureContactGroupLoaded() {
    return this.ensureAssociationLoaded("contact_group")
  }
}
